/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Status_LiveInputs */

const th_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังรับวิดีโอ`)
};

const en_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receiving video.`)
};

const ja_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`映像を受信中です。`)
};

const zh_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在接收视频。`)
};

const es_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibiendo vídeo.`)
};

const pt_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recebendo vídeo.`)
};

const id_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menerima video.`)
};

const fr_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réception de la vidéo.`)
};

const tl_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tumatanggap ng video.`)
};

const vi_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang nhận video.`)
};

const ko_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`영상을 받고 있습니다.`)
};

const de_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video wird empfangen.`)
};

const ru_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Принимаем видео.`)
};

const tr_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görüntü alınıyor.`)
};

const it_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricezione del video.`)
};

const pl_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odbieranie obrazu.`)
};

const uk_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отримуємо відео.`)
};

const hi_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो मिल रहा है।`)
};

const ar_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يجري استقبال الفيديو.`)
};

const ms_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menerima video.`)
};

const bn_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভিডিও আসছে।`)
};

const zh_tw2_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在接收影片。`)
};

const zh_hk2_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在接收短片。`)
};

const ur_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ویڈیو مل رہی ہے۔`)
};

const fa_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصویر دریافت می‌شود.`)
};

const sw_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inapokea video.`)
};

const nl_video_status_live = /** @type {(inputs: Video_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beeld wordt ontvangen.`)
};

/**
* | output |
* | --- |
* | "Receiving video." |
*
* @param {Video_Status_LiveInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_status_live = /** @type {((inputs?: Video_Status_LiveInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Status_LiveInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_status_live(inputs)
	if (locale === "ja") return ja_video_status_live(inputs)
	if (locale === "zh") return zh_video_status_live(inputs)
	if (locale === "es") return es_video_status_live(inputs)
	if (locale === "pt") return pt_video_status_live(inputs)
	if (locale === "id") return id_video_status_live(inputs)
	if (locale === "fr") return fr_video_status_live(inputs)
	if (locale === "tl") return tl_video_status_live(inputs)
	if (locale === "vi") return vi_video_status_live(inputs)
	if (locale === "ko") return ko_video_status_live(inputs)
	if (locale === "de") return de_video_status_live(inputs)
	if (locale === "ru") return ru_video_status_live(inputs)
	if (locale === "tr") return tr_video_status_live(inputs)
	if (locale === "it") return it_video_status_live(inputs)
	if (locale === "pl") return pl_video_status_live(inputs)
	if (locale === "uk") return uk_video_status_live(inputs)
	if (locale === "hi") return hi_video_status_live(inputs)
	if (locale === "ar") return ar_video_status_live(inputs)
	if (locale === "ms") return ms_video_status_live(inputs)
	if (locale === "bn") return bn_video_status_live(inputs)
	if (locale === "zh-TW") return zh_tw2_video_status_live(inputs)
	if (locale === "zh-HK") return zh_hk2_video_status_live(inputs)
	if (locale === "ur") return ur_video_status_live(inputs)
	if (locale === "fa") return fa_video_status_live(inputs)
	if (locale === "sw") return sw_video_status_live(inputs)
	if (locale === "nl") return nl_video_status_live(inputs)
	return en_video_status_live(inputs)
});